import {
  ssnOrVaFileNumberNoHintSchema,
  ssnOrVaFileNumberNoHintUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  veteranFields,
  veteranInformationText,
} from '../definitions/constants';

const veteranIdentificationUI = ssnOrVaFileNumberNoHintUI();

export default {
  uiSchema: {
    ...titleUI(
      veteranInformationText.pageContTitle,
      veteranInformationText.pageContDescription,
    ),
    'ui:options': { preserveHiddenData: true, forceDivWrapper: true },
    [veteranFields.parentObject]: {
      ...veteranIdentificationUI,
      [veteranFields.ssn]: {
        ...veteranIdentificationUI[veteranFields.ssn],
        'ui:errorMessages': {
          pattern: veteranInformationText.ssnPatternError,
          required: veteranInformationText.ssnRequiredError,
        },
      },
      [veteranFields.vaFileNumber]: {
        ...veteranIdentificationUI[veteranFields.vaFileNumber],
        'ui:title': veteranInformationText.vaFileNumberTitle,
        'ui:options': {
          ...veteranIdentificationUI[veteranFields.vaFileNumber]['ui:options'],
          hint: veteranInformationText.vaFileNumberHint,
        },
        'ui:errorMessages': {
          pattern: veteranInformationText.vaFileNumberPatternError,
        },
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      [veteranFields.parentObject]: {
        type: 'object',
        properties: {
          ...ssnOrVaFileNumberNoHintSchema.properties,
        },
        required: [...ssnOrVaFileNumberNoHintSchema.required],
      },
    },
  },
};
